// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backarrow {
    text-decoration: none;
    color: #000000 !important;
    font-size: 16px;
    font-weight: 600;
}

.red-border {
    border: 1px solid red !important;
}

.errorred {
    color: red;
    font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Settings/Site_Setting/site_setting.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,eAAe;AACnB","sourcesContent":[".backarrow {\n    text-decoration: none;\n    color: #000000 !important;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.red-border {\n    border: 1px solid red !important;\n}\n\n.errorred {\n    color: red;\n    font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
